/* eslint-disable sort-imports */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
import { Typography } from '@equinor/eds-core-react';
import { HandleModelComponent } from '../../features/HandleModel/HandleModelComponent/HandleModelComponent';
import { ModelAddView } from '../../features/ModelView/ModelAddView/ModelAddView';
import * as Styled from './AddModel.styled';
import { useModelFormStore } from '../../stores/ModelFormStore';
import { useAddModelStore } from './stores/AddModelStore';

export const AddModel = () => {
  const analogueModel = useModelFormStore((s) => s.analogueModel);
  const { uploadStatus } = useAddModelStore();

  return (
    <Styled.Content>
      <Typography variant="h2" as="h1">
        New model
      </Typography>
      <HandleModelComponent />
      {analogueModel.analogueModelId !== '' && (
        <>
          <ModelAddView uploadingStatus={uploadStatus} />
        </>
      )}
    </Styled.Content>
  );
};
